import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css'



/*
configure properties from file, even after build application.
fetch('/config/config.json')
     .then(resp => resp.json())
     .then(data => console.log(JSON.stringify(data))) */

ReactDOM.render(
  /* gives error for bootstrap modal pop-up if its in strict mode */
  /*<React.StrictMode> */
    <App />,
  /* <React.StrictMode>, */
  document.getElementById('root')
);
